import styled from 'styled-components';
import { LongBody } from 'components/Typography';

export const StyledLongBody = styled(LongBody)`
  && {
    margin: 0;
  }
`;

export const StyledForm = styled.form`
  @media only screen and (min-width: 320px) {
    max-width: 80vw;
  }
  @media only screen and (min-width: 768px) {
    max-width: 60vw;
  }
  @media only screen and (min-width: 1200px) {
    max-width: 40vw;
  }
`;
